import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/components/Login.vue'
import Register from '@/components/Register.vue'
import Home from '@/components/user/Home.vue'
import Welcome from '@/components/user/Welcome.vue'
import Dataset from '@/components/user/Dataset.vue' 
import Assess from '@/components/user/Assess.vue'
import Progress from '@/components/user/Progress.vue' 
import ShowMetric from '@/components/user/ShowMetric.vue'
import Ana from '@/components/user/Ana.vue'
Vue.use(VueRouter)
import VerifyEmail from '@/components/VerifyEmail.vue'

const routes = [
    {
  path: '/verify-email',
  component: VerifyEmail
},
  {
    path: '/',
    redirect:'/login'
  },
  {
    path:"/register",
    component:Register,
},
  {
    path: '/login',
    component: Login,
  },
  {
    path:"/home",
    component:Home,
    redirect:"/welcome",
    children:
    [
      {path:"/welcome",component:Welcome,},
      {path:"/dataset",component:Dataset,},
      {path:"/assess",component:Assess,},
      {path:"/progress",component:Progress,},
      {path:"/showmetric",component:ShowMetric,},
      { path:"/ana", component: Ana,},
    ]
  },
]

const router = new VueRouter({
  routes
})
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to:将要访问的路径
  // from:从哪里访问的路径
  // next:之后要做的任务，是一个函数
  //    next（）放行， next（'/URL'）强制跳转的路径。
  if (to.path == '/login') return next();// 访问路径为登录
  if (to.path == '/register') return next();// 访问路径为注册
  if (to.path == '/verify-email') return next();// 访问路径为注册

  // 获取flag
  const flagStr = window.sessionStorage.getItem("user");// session取值
  if (!flagStr) return next('/login');// 没登录去登录
  next();
  
})

export default router// 暴露出去
